/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Clearfiltertohide4Inputs */

const en_datagrid_clearfiltertohide4 = /** @type {(inputs: Datagrid_Clearfiltertohide4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear its filter to hide this column`)
};

/**
* | output |
* | --- |
* | "Clear its filter to hide this column" |
*
* @param {Datagrid_Clearfiltertohide4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_clearfiltertohide4 = /** @type {((inputs?: Datagrid_Clearfiltertohide4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Clearfiltertohide4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_clearfiltertohide4(inputs)
});
export { datagrid_clearfiltertohide4 as "dataGrid_clearFilterToHide" }